module.exports = __webpack_public_path__ + "static/media/fo.41e3ffaf.svg";